/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_Not_Allowed_For_InsurerInputs */

const es_co2_error_passkey_not_allowed_for_insurer = /** @type {(inputs: Error_Passkey_Not_Allowed_For_InsurerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los usuarios de aseguradora no pueden usar una llave estándar.`)
};

/**

* @param {Error_Passkey_Not_Allowed_For_InsurerInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_not_allowed_for_insurer = /** @type {((inputs?: Error_Passkey_Not_Allowed_For_InsurerInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_Not_Allowed_For_InsurerInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_not_allowed_for_insurer(inputs)
});